module.exports = __webpack_public_path__ + "img/tt.e2a302da.svg";